import {
  DASHBOARD_MENU_AVAILABLE_BEGIN,
  DASHBOARD_MENU_AVAILABLE_FAILURE,
  DASHBOARD_MENU_AVAILABLE_SUCCESS,
} from "../actions/1_ActionConstants";

const initialState = {
  loading: false,
  error: null,
  isDashboardMenuAvailable: false,
};

export default function IsDashboardMenuAvailableReducer(state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_MENU_AVAILABLE_BEGIN:
      return {
        loading: true,
        ...state,
      };

    case DASHBOARD_MENU_AVAILABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        isDashboardMenuAvailable: action.payload,
      };

    case DASHBOARD_MENU_AVAILABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: "FAILED TO LOAD,..,.",
        isDashboardMenuAvailable: false,
      };
    default:
      return state;
  }
}
